import type {Ref} from "vue";
import type {JsonApiResponse} from "~/types/JsonApiResponse";
import type {ProjectData} from "~/types/ProjectData";
import type {UserData} from "~/types/UserData";
import type {CommentData} from "~/types/CommentData";

export const useAuthor = () => {
    const getAuthor = (userUuid: string) => {
        return useAsyncData<JsonApiResponse<UserData>>(`author:${userUuid}`, () => $api(`/api/author/${userUuid}`))
    }
    const getProjects = (userUuid: string, page: Ref<number>) => {
        return useAsyncData<JsonApiResponse<ProjectData[]>>(`author:${userUuid}:projects`, () => $api(`/api/author/${userUuid}/projects/`, {
            query: {
                page: page.value
            },
        }), {
            watch: [page]
        })
    }
    const getComments = (userUuid: string, page: Ref<number>) => {
        return useAsyncData<JsonApiResponse<CommentData[]>>(`author:${userUuid}:comments`, () => $api(`/api/author/${userUuid}/comments/`, {
            query: {
                page: page.value
            },
        }), {
            watch: [page]
        })
    }

    const isSubscribed = (userUuid: string) => {
        return useAsyncData<JsonApiResponse<{ status: boolean }>>(`author:${userUuid}:is-subscribed`, () => $api(`/api/author/${userUuid}/is-subscribed`))
    }

    const toggleSubscription = (userUuid: string) => {
        return $api(`/api/author/${userUuid}/toggle-subscription`, {
            method: 'POST'
        })
    }

    return {
        getAuthor,
        getProjects,
        getComments,
        isSubscribed,
        toggleSubscription
    }
}
